import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import { useSelector, useDispatch } from 'react-redux';
import { closeAlertDialog } from '../../redux/actions/dialogActions';
import { makeStyles } from '@material-ui/core/styles';
import classeNames from 'classnames';

const useStyles = makeStyles((theme) => ({
	smDialogContent: {
		whiteSpace: 'pre-wrap',
	},
	dialogContent: {
		overflowWrap: 'anywhere',
	},
}));

//material ui animation to slide dialog up
const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

//custom re-usable dialog
const AlertDialogSlide = () => {
	//state is managed by UIreducer
	const state = useSelector((state) => state.ui.dialog);
	const dispatch = useDispatch();
	const classes = useStyles();
	const DialogContentClasses = classeNames({
		[classes.smDialogContent]: state.size === 'sm',
		[classes.dialogContent]: true,
	});

	const handleClose = () => {
		dispatch(closeAlertDialog(false));
	};

	return (
		<div>
			<Dialog
				open={state.open}
				data-cy="dialog-component"
				TransitionComponent={Transition}
				keepMounted
				onClose={handleClose}
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
				maxWidth={state.size ?? 'lg'} // make the default dialog size to lg, if not provided from state.
				fullWidth={true}
			>
				<DialogTitle id="alert-dialog-slide-title">{state.title}</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-slide-description" className={DialogContentClasses}>
						{state.content}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						OK
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};
export default AlertDialogSlide;
